import { Capacitor } from '@capacitor/core';

/** Nudge layout after the native WebView may still be stuck at keyboard height. */
function nudgeViewportLayout() {
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
    window.visualViewport?.dispatchEvent(new Event('resize'));
  });
}

/**
 * Blur focused input, hide the IME, and nudge layout.
 * Use after navigation or when Android leaves a ghost keyboard gap.
 */
export async function dismissNativeKeyboard(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  const active = document.activeElement;
  if (active instanceof HTMLElement) {
    active.blur();
  }

  try {
    const { Keyboard } = await import('@capacitor/keyboard');
    await Keyboard.hide().catch(() => {});
  } catch {
    /* plugin unavailable */
  }

  nudgeViewportLayout();
}

let recoveryInitialized = false;

/**
 * Register keyboardDidHide recovery once at app startup (native only).
 */
export function initNativeKeyboardRecovery(): void {
  if (!Capacitor.isNativePlatform() || recoveryInitialized) return;
  recoveryInitialized = true;

  import('@capacitor/keyboard')
    .then(({ Keyboard }) => {
      Keyboard.addListener('keyboardDidHide', () => {
        nudgeViewportLayout();
      });
    })
    .catch(() => {});
}
